import {Box, CircularProgress, Grid} from '@mui/material';
import {AppIconButton} from 'components/buttons';
import {AppControlledInput} from 'components/form';
import {MainCard} from 'components/Theme';
import {Add} from 'iconsax-react';
import React, {useEffect, useRef} from 'react';
import {useForm} from 'react-hook-form';

interface AddKanbanItemInputProps {
    onAddITemSubmit: (title: string) => void;
    inputTitle: string;
    isLoading: boolean;
}

interface KabbanAddItemType {
    Title: string;
}
export const AddKanbanItemInput: React.FC<AddKanbanItemInputProps> = ({
    inputTitle,
    isLoading = false,
    onAddITemSubmit,
}) => {
    const inputRef = useRef<HTMLInputElement>(null);
    const {control, handleSubmit} = useForm<KabbanAddItemType>({
        defaultValues: {Title: ''},
    });
    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);
    const onAddITemSubmitHandler = (data: KabbanAddItemType) => {
        onAddITemSubmit(data.Title);
    };

    return (
        <Box mb={1} component={'form'} onSubmit={handleSubmit(onAddITemSubmitHandler)} width={'100%'}>
            <MainCard content={false}>
                <Box sx={{p: 1, py: 2, transition: 'background-color 0.25s ease-out'}}>
                    <Grid container alignItems="center" position={'relative'} justifyContent={'flex-end'}>
                        <Grid item style={{position: 'absolute', top: -10, right: 0}}>
                            {isLoading ? (
                                <CircularProgress size={20} />
                            ) : (
                                <AppIconButton type="submit" size="small">
                                    <Add />
                                </AppIconButton>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <AppControlledInput
                                required
                                fullWidth
                                placeholder="Add Item"
                                inputRef={inputRef}
                                control={control}
                                name="Title"
                                label={inputTitle}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </MainCard>
        </Box>
    );
};

export default AddKanbanItemInput;
